import {
  CategoryListResponse,
  Category
} from '@/modules/settings/categories/types/Category.ts'

export const categoriesPage1: { data: CategoryListResponse } = {
  data: {
    results: [
      {
        id: '1',
        name: 'Electrónicos',
        description: 'Productos electrónicos y tecnológicos',
        quotes: '100',
        exchange: '1.27',
        timesQuotes: '30',
        isActive: true,
        rentabilityId: '1'
      },
      {
        id: '2',
        name: 'Ropa',
        description: 'Vestimenta y accesorios',
        quotes: '50',
        exchange: '1.4',
        timesQuotes: '15',
        isActive: true,
        rentabilityId: '2'
      },
      {
        id: '3',
        name: 'Hogar',
        description: 'Artículos para el hogar',
        quotes: '75',
        exchange: '1.1',
        timesQuotes: '20',
        isActive: false,
        rentabilityId: '1'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 0
    }
  }
}

export const categoryDetail: { data: Category } = {
  data: {
    id: '9',
    name: 'TV',
    description:
      'Televisores y accesorios relacionados con el entretenimiento visual',
    rentabilityId: '1',
    quotes: '4',
    exchange: '1.27',
    timesQuotes: '14',
    isActive: true
  }
}
